import { Injectable } from '@angular/core';
import { ProfileRepository } from '../repositories/profile.repository';
import { Observable } from 'rxjs';
import { ProfileModel } from '../../data/models/profile.model';
import { map } from 'rxjs/operators';
import tokenHelper from '../../common/tokenHelper';
import { PostModel } from '../../data/models/post.model';
import { PostingStatusEnum } from '../../data/enum/post.enum';
import { ISearchUserItem } from '../../data/interface/user.interface';
@Injectable({
	providedIn: 'root'
})
export class ProfileUsecase {
	constructor(private profileRepository: ProfileRepository) {}

	getDetailProfile(username: string | null): Observable<ProfileModel> {
		if (!username) {
			const token = tokenHelper.getAccessToken();
			if (token) {
				username = tokenHelper.decodeToken(token).username;
			}
		}

		return this.profileRepository.getDetailProfile(username || '').pipe(
			map((result: any) => {
				return result.data;
			})
		);
	}

	getAllPublishedPostBySelf(): Observable<PostModel[]> {
		const token = tokenHelper.getAccessToken();
		const username = tokenHelper.decodeToken(token || '').username;

		return this.profileRepository.getAllPostByUser(username, PostingStatusEnum.PUBLISHED).pipe(
			map((result: any) => {
				return result.data;
			})
		);
	}

	getAllPublishedPost(username: string): Observable<PostModel[]> {
		return this.profileRepository.getAllPostByUser(username, PostingStatusEnum.PUBLISHED).pipe(
			map((result: any) => {
				return result.data;
			})
		);
	}

	getBookmarkByUser(): Observable<any> {
		const token = tokenHelper.getAccessToken();
		const username = tokenHelper.decodeToken(token || '').username;

		return this.profileRepository.getBookmarkByUser(username).pipe(
			map((result: any) => {
				if (result.data) {
					return result.data;
				} else {
					return [];
				}
			})
		);
	}

	getDetailProfileById(id: string | null): Observable<ISearchUserItem> {
		if (!id) {
			const token = tokenHelper.getAccessToken();
			if (token) {
				id = tokenHelper.decodeToken(token).userId;
			}
		}

		return this.profileRepository.getDetailProfileById(id || '').pipe(
			map((result: any) => {
				return result.data;
			})
		);
	}
}
